// @flow
import { tryTrack } from "../helpers"
import { formatVariantParam } from "data/product/formatters"
import type { ProductVariant } from "data/product/types"
import type { User } from "data/user/types"

export const productTrait = (
  productVariant: ProductVariant,
  user: User,
) => ({
  email: user.email,
  subscription: user.subscription ? "perks" : "flex",
  productId: productVariant.id,
  productGroup: productVariant.product.productGroup.name,
  brand: productVariant.product.manufacturer.name,
  model: productVariant.product.name,
  width: formatVariantParam("width")(productVariant.parameters),
  length: formatVariantParam("length")(productVariant.parameters),
  thickness: formatVariantParam("thickness")(productVariant.parameters),
  volume: formatVariantParam("volume")(productVariant.parameters),
  gender: formatVariantParam("gender")(productVariant.parameters),
  binding: formatVariantParam("binding")(productVariant.parameters),
  terrain: formatVariantParam("terrain")(productVariant.parameters),
})

export const trackProductView = (p: ProductVariant, u: User) =>
  tryTrack("Product Viewed", () => productTrait(p, u))



// WEBPACK FOOTER //
// ./src/analytics/product/analyticsTraits.js